import { TabPanel } from '@warp-ds/react/components/tabs';
import type { LevelFactory } from '@/components/factory';
import type { Vertical } from '@/data/verticals';

interface Props {
    factory: LevelFactory;
    vertical: Vertical;
}

export const Search = ({ factory, vertical }: Props) => {
    const { SearchComponent } = factory.menuValues();

    return (
        <section data-testid="searchFormContent">
            <TabPanel name={vertical}>
                <SearchComponent />
            </TabPanel>
        </section>
    );
};
